export const UploadFileArrow = () => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3681_285)">
      <path
        d="M3 14.4418H13V11.4418H15V16.4418H1V11.4418H3V14.4418ZM12.707 4.73475C13.0975 5.12528 13.0975 5.75832 12.707 6.14881C12.3165 6.53921 11.6835 6.53921 11.293 6.14881L9 3.85585V11.4418C8.99989 11.994 8.55222 12.4418 8 12.4418C7.44778 12.4418 7.00011 11.994 7 11.4418V3.85585L4.70703 6.14881C4.31653 6.53921 3.68347 6.53921 3.29297 6.14881C2.90248 5.75832 2.90254 5.12528 3.29297 4.73475L7.29297 0.734752L8 1.44178L8.70703 0.734752L12.707 4.73475ZM7.36914 0.665416C7.73585 0.366716 8.26533 0.367246 8.63184 0.666393L8.70703 0.734752L8 1.44178L7.29297 0.734752L7.36914 0.665416Z"
        fill="#0D2727"
      />
    </g>
    <defs>
      <clipPath id="clip0_3681_285">
        <rect width="16" height="16" fill="white" transform="translate(0 0.441711)" />
      </clipPath>
    </defs>
  </svg>
);
